import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { DxDataGridComponent, DxDropDownBoxComponent } from 'devextreme-angular';
import { ConteneurDto } from 'src/api/models';
import { DevExtremeTranslationService } from 'src/core/services/devExtremeTranslation.service';
import { PanelLayoutService } from 'src/core/services/panel-layout.service';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-conteneur-select',
  templateUrl: './conteneur-select.component.html',
  styleUrls: ['./conteneur-select.component.css']
})
export class ConteneurSelectComponent implements OnInit, OnDestroy {
  @ViewChild('dxDropDown') dropDown: DxDropDownBoxComponent;
  @ViewChild('dataGrid') dataGrid: DxDataGridComponent;

  @Select(ControlPanelStore.conteneurs$) conteneurs$: Observable<ConteneurDto[]>;

  @Input() width: number;

  @Input() Conteneurs: ConteneurDto[] = null;
  @Input() conteneurId: number;
  @Input() titleNull: string = null;
  @Output() conteneurIdChange = new EventEmitter<number>();

  @Input() cell: any;

  @Input() disabled: boolean = false;

  InitId = null;

  SelectedConteneur: ConteneurDto = null;
  ColumnName = [];

  c: Subscription;

  constructor(private panelLayoutService: PanelLayoutService,
    private translate: TranslateService,
    private devExtremeTranslationService: DevExtremeTranslationService) {
    // Instanciate Globalize for DevExtreme components
    this.devExtremeTranslationService.loadLanguage(this.translate.getBrowserLang());

    this.translate.get(
      [
        'Identifiant'
      ]
    ).subscribe(translations => {
      this.ColumnName.push(translations['Identifiant']);
    });
  }

  ngOnInit() {
    if (this.conteneurId != null) {
      this.InitId = JSON.parse(JSON.stringify(this.conteneurId));
    }

    if (!this.Conteneurs) {
      this.c = this.conteneurs$.subscribe((res:ConteneurDto[]) => {
        if (res != null) {
          this.Conteneurs = res;
        }
      });
    }
    else {
      if (this.titleNull && !this.Conteneurs.find(p => p.Id == 0)) {
        this.Conteneurs.unshift({ Id: 0, Identifiant: this.titleNull });
      }
      if (!this.conteneurId) {
        this.conteneurId = 0;
      }
     }
  }

  ngOnDestroy() {
    this.c?.unsubscribe();
  }

  updateInfo(event) {
    this.conteneurId = event.currentSelectedRowKeys.length === 1 ? event.currentSelectedRowKeys[0].Id : this.conteneurId;
    if (!!this.cell && this.InitId !== this.conteneurId) {
      this.cell.setValue(this.conteneurId);
    }
    this.conteneurIdChange.emit(this.conteneurId);

    if(this.conteneurId != null) {
      this.dropDown.instance.close();
    }
  }

  onOpened() {
    if(this.conteneurId == null) {
      this.dataGrid.instance.clearSelection();
    }
  }
}
